import React from "react";
import { motion } from "framer-motion";

const ServicesSvg = (props) => (
  <motion.svg
    xmlns="http://www.w3.org/2000/svg"
    width={92}
    height={91}
    fill="none"
    {...props}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1 }} n
  >
    <motion.g
      clipPath="url(#a)"
      initial={{ rotate: 0 }}
      animate={{ rotate: 5 }}
      transition={{
        repeat: Infinity,
        repeatType: "reverse",
        duration: 4,
        ease: "easeInOut",
      }}
    >
      <motion.path
        fill="#051A2F"
        d="M67.736 17.997c-.804-5.032-3.214-9.326-7.074-12.536C56.667 2.14 51.344.201 45.67.001a1.957 1.957 0 0 0-.151 0c-5.675.2-11 2.139-14.995 5.46-3.86 3.21-6.264 7.503-7.068 12.536a3.93 3.93 0 0 0-3.785 3.932v5.818c0 2.17 1.745 3.961 3.914 3.961h1.757c1.203 0 2.172-1.002 2.172-2.205V21.01C27.95 9.964 36.893 4.693 45.596 4.36c8.703.334 17.646 5.604 18.082 16.652v6.413l-2.571.12c.287-1.711.398-3.53.327-5.434-.366-9.78-8.427-14.51-15.761-14.768a1.994 1.994 0 0 0-.153 0c-7.334.257-15.395 4.988-15.761 14.767-.303 8.083 2.71 14.611 8.265 17.911a14.812 14.812 0 0 0 15.143 0c3.044-1.808 5.324-4.573 6.715-8.045l6.018-.266h1.706c2.17 0 3.915-1.792 3.915-3.962v-5.818a3.931 3.931 0 0 0-3.785-3.932Zm-11.113 9.755-7.953.37a2.179 2.179 0 1 0 .203 4.353l6.054-.282c-1.007 1.72-2.347 3.108-3.986 4.082a10.46 10.46 0 0 1-10.692 0c-4.14-2.46-6.377-7.564-6.136-14.003.262-7.002 5.943-10.35 11.483-10.573 5.54.223 11.22 3.57 11.482 10.573.073 1.963-.084 3.802-.455 5.48Zm8.265 32.949C63.086 50.97 53.9 46.615 45.596 46.615c-8.305 0-17.492 4.356-19.294 14.086L21.168 88.42a2.148 2.148 0 0 0 .468 1.775 2.166 2.166 0 0 0 1.674.771h32.143a2.179 2.179 0 0 0 0-4.357H25.93l4.657-25.13c.666-3.594 2.754-6.166 5.482-7.889.933 3.231 4.649 5.35 9.525 5.35h.002c4.876 0 8.592-2.111 9.526-5.342 2.728 1.723 4.816 4.318 5.482 7.913l5.134 27.71a2.176 2.176 0 0 0 2.54 1.74 2.18 2.18 0 0 0 1.745-2.54L64.888 60.7Zm-13.942-8.349c-.319 1.233-2.669 2.232-5.35 2.232h-.002c-2.68 0-5.03-1-5.35-2.232l-.144-.574a19.442 19.442 0 0 1 5.496-.797c1.827 0 3.706.27 5.495.801l-.145.57Z"
      />
    </motion.g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.098 0h91v91h-91z" />
      </clipPath>
    </defs>
  </motion.svg>
);

export default ServicesSvg;
